import React from "react";
import {FaBookOpen, FaFire, FaRegCalendarAlt} from "react-icons/fa";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const baseurl = "https://www.saiparivarfoundation.org/images/Temple/";

const ids = [1,2,3,4,5,6,7,8,9,10];

const Activities = [
    {
        name: "Sai Sandhya - every Thursday & Saturday 6:00 PM.",
        icon: FaFire,
    },
    {
        name: "Satsang - every Thursday & Saturday 6:30 PM.",
        icon: FaBookOpen,
    },
    {
        name: "Recital of “Guru Bhagawat” as well discuss and exchange learning from Baba’s teachings.",
        icon: FaBookOpen,
    },
    {
        name: "Food and clothes drives to help distribute among the poor and needy.",
        icon: FaRegCalendarAlt,
    }
];

const AboutUs = () => {
    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <p className="mt-3 text-3xl font-bold tracking-tight text-red-900 sm:text-4xl">
                                About us-
                            </p>
                            <p className="mt-6 text-lg leading-8 text-black-600">
                                We are a non-profit organization registered in the state of Washington.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-black-600">
                                Shirdi Sai Dham Temple is a spiritual and cultural sanctuary dedicated to the teachings and blessings of Shirdi Sai Baba. The temple serves as a peaceful place of worship for devotees seeking guidance, faith, and inner transformation through prayer, meditation, and service.

Rooted in the timeless message of “Sabka Malik Ek” (One God governs all), the temple welcomes people from all backgrounds, fostering unity, compassion, and humility. Regular prayers, bhajans, aarti, and spiritual discourses are conducted to help devotees deepen their connection with Sai Baba’s teachings.

Beyond worship, the temple actively engages in community service and charitable initiatives, supporting those in need and promoting values of kindness, selflessness, and seva (service). It also hosts religious festivals and cultural events that bring the community together in devotion and celebration.

Shirdi Sai Dham Temple stands as a beacon of faith, hope, and harmony—offering a sacred space for reflection, devotion, and spiritual growth.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-black-600">
                                OUR MISSION: To spread Shirdi Sai Baba’s philosophy and teachings, Shraddha (devotion)
                                and Saburi (patience).
                            </p>
                            <li>The Sai Age and be a part of Sai-ism, as He is the Master of the Age.</li>
                            <li>Spread the message of love, purity and sanctifying the lives in the service of Lord
                                Shirdi Sai.
                            </li>
                            <br/>
                            <h2 className="text-base font-semibold leading-7 text-orange-600">
                                Activities
                            </h2>
                            {/* Features List */}
                            <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-red-600 lg:max-w-none">
                                {Activities.map((feature) => (
                                    <div key={feature.name} className="relative pl-9">
                                        {/* Feature Title with Icon */}
                                        <dt className="inline font-semibold text-red-900">
                                            <feature.icon
                                                className="absolute left-1 top-1 h-5 w-5 text-orange-600"
                                                aria-hidden="true"
                                            />
                                            {feature.name}
                                        </dt>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                    <div className="flex mt-6 justify-center lg:justify-start">
                    <Carousel autoPlay={true} infiniteLoop={true} useKeyboardArrows={true}>
                        {ids.map(id => (
                            <div className="flex justify-center lg:justify-start box" key={id}>
                                <img
                                src={baseurl + id + ".JPG"}
                                width={2432}
                                height={1442}
                                className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                alt=""
                                />
                            </div>
                            
                        ))}
                    </Carousel>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUs